import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Strategy } from "../models";
import { environment } from "environments/environment";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs";

@Injectable({providedIn:'root'})
export class StrategyService{
    constructor(private _http:HttpClient){}

    getAll(){
        return this._http.get<Strategy[]>(`${environment.innovationApiUrl}/api/strategy`);
    }

    getById(id: number) {
    return this._http.get<Strategy>(`${environment.rydApiUrl}/api/strategy/${id}`);
    }

    addStrategy(strategy) {
        return this._http.post<Strategy>(`${environment.rydApiUrl}/api/strategy`, strategy).pipe(
            map((response: any) => response.strategy as Strategy),
            catchError(e => {
                return throwError(e);
            })
        );
    }

    editStrategy(strategy) {
        return this._http.put<Strategy>(`${environment.rydApiUrl}/api/strategy/${strategy.id}`, strategy).pipe(
            map((response: any) => response.strategy as Strategy),
            catchError(e => {
                return throwError(e);
            })
        );
    }

    changeStatus(id: number, statusId: number) {
        return this._http.put<Strategy>(`${environment.rydApiUrl}/api/strategy/${id}/${statusId}`, {}).pipe(
            map((response: any) => response.strategy as Strategy),
            catchError(e => {
                return throwError(e);
            })
        );
    }

}
